module.exports = __webpack_public_path__ + "static/media/google-play-en.cc566896.svg";